<template>
  <div class="pay-out-test">
    <a-form-model :form="form" layout="vertical" :rules="rules" ref="form" :model="saveObject">
      <!-- 应用选择 -->
      <a-form-model-item label="应用选择" prop="appId">
        <a-select
          v-model="saveObject.appId"
          placeholder="请选择应用"
          style="width: 100%"
          @change="handleAppChange"
        >
          <a-select-option v-for="app in appList" :key="app.appId" :value="app.appId">
            {{ app.appName }} [{{ app.appId }}]
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 代付通道 -->
      <a-form-model-item label="代付通道" prop="wayCode">
        <a-select
          v-model="saveObject.wayCode"
          placeholder="请选择代付通道"
          style="width: 100%"
          :disabled="!saveObject.appId"
        >
          <a-select-option v-for="channel in channelList" :key="channel.wayCode" :value="channel.wayCode">
            {{ channel.wayCode }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 金额 -->
      <a-form-model-item label="金额(元)" prop="amount">
        <a-input-number
          v-model="saveObject.amount"
          :min="0.01"
          :max="100000"
          :precision="2"
          style="width: 100%"
          placeholder="请输入金额"
        />
      </a-form-model-item>

      <!-- 银行卡号 -->
      <a-form-model-item label="银行卡号" prop="accountNo">
        <a-input
          v-model="saveObject.accountNo"
          placeholder="请输入银行卡号"
          allowClear
        />
      </a-form-model-item>

      <!-- 姓名 -->
      <a-form-model-item label="银行账户名" prop="accountHolder">
        <a-input
          v-model="saveObject.accountHolder"
          placeholder="请输入银行账户名"
          allowClear
        />
      </a-form-model-item>

      <!-- IFSC编码 -->
      <a-form-model-item label="IFSC编码" prop="ifsc">
        <a-input
          v-model="saveObject.ifsc"
          placeholder="请输入IFSC编码"
          allowClear
        />
      </a-form-model-item>

      <!-- 回调地址 -->
      <a-form-model-item label="回调地址" prop="notifyUrl">
        <a-input
          v-model="saveObject.notifyUrl"
          placeholder="请输入回调地址"
          allowClear
        />
      </a-form-model-item>

      <!-- 提交按钮 -->
      <a-form-model-item>
        <a-button type="primary" @click="handleSubmit" :loading="loading">
          下单测试
        </a-button>
      </a-form-model-item>
    </a-form-model>

    <!-- 结果展示 -->
    <div v-if="result" class="result-container">
      <a-divider>测试结果</a-divider>
      <a-alert
        :type="result.code === 0 ? 'success' : 'error'"
        :message="result.code === 0 ? '测试成功' : '测试失败'"
        :description="result.msg"
        show-icon
      />
      <a-descriptions v-if="result.code === 0" title="订单信息" bordered :column="1" style="margin-top: 20px">
        <a-descriptions-item v-for="(value, key) in result.data" :key="key" :label="key">
          {{ value }}
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>

<script>
import { getMchAppList, getPayOututIntegrationChannel, createPayOutOrder } from '@/api/integration'

export default {
  name: 'PayOutTest',
  data () {
    return {
      form: this.$form.createForm(this),
      appList: [],
      channelList: [],
      loading: false,
      result: null,
      rules: {
        appId: [{ required: true, message: '请选择应用' }],
        wayCode: [{ required: true, message: '请选择代付通道' }],
        amount: [{ required: true, message: '请输入金额' }, { type: 'number', min: 0.01, message: '金额需大于0' }],
        accountNo: [{ required: true, message: '请输入银行卡号' }],
        accountHolder: [{ required: true, message: '请输入姓名' }],
        ifsc: [{ required: true, message: '请输入IFSC编码' }],
        notifyUrl: [{ required: true, message: '请输入回调地址' }, { type: 'url', message: '请输入正确的URL' }]
      },
      saveObject: {
        appId: '',
        wayCode: '',
        amount: 0.01,
        accountNo: null,
        accountHolder: null,
        ifsc: null,
        notifyUrl: ''
      }
    }
  },
  mounted () {
    this.loadAppList()
    // 设置表单初始值，确保校验生效
    this.$nextTick(() => {
      this.form.setFieldsValue({
        appId: '',
        wayCode: '',
        amount: 0.01,
        accountNo: '',
        accountHolder: '',
        ifsc: '',
        notifyUrl: ''
      })
    })
  },
  methods: {
    // 加载应用列表
    async loadAppList () {
      try {
        const res = await getMchAppList()
        if (res && res.records) {
          this.appList = res.records
          if (this.appList.length > 0) {
            this.saveObject.appId = this.appList[0].appId
            this.handleAppChange(this.saveObject.appId)
          }
        }
      } catch (error) {
        console.error('获取应用列表失败', error)
        this.$message.error('获取应用列表失败')
      }
    },

    // 应用变更
    async handleAppChange (appId) {
      if (!appId) {
        this.channelList = []
        this.saveObject.wayCode = ''
        return
      }

      try {
        const res = await getPayOututIntegrationChannel(appId)
        this.channelList = res || []
        if (this.channelList.length > 0) {
          this.saveObject.wayCode = this.channelList[0].wayCode
        } else {
          this.saveObject.wayCode = ''
        }
      } catch (error) {
        console.error('获取代付通道失败', error)
        this.$message.error('获取代付通道失败')
        this.channelList = []
        this.saveObject.wayCode = ''
      }
    },

    // 提交测试
    async handleSubmit () {
      // 先进行表单校验
      try {
        // await this.validateForm()
        const that = this
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            // 验证通过
            await that.submitOrder()
          }
        })
        // 校验通过后执行提交
        // await this.submitOrder()
      } catch (error) {
        console.error('表单校验失败:', error)
        // 校验失败的错误已经在validateForm中处理了
      }
    },

    // 提交订单
    async submitOrder () {
      this.loading = true
      try {
        const res = await createPayOutOrder(this.saveObject)
        this.result = {
          code: 0,
          data: res,
          msg: '测试成功'
        }
        this.$message.success('测试成功')
      } catch (error) {
        console.error('提交测试失败', error)
        this.result = {
          code: -1,
          msg: error.message || error.msg || '请求异常，请检查网络或联系管理员'
        }
        this.$message.error(this.result.msg)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pay-out-test {
  padding: 20px;
  background-color: #fff;

  .result-container {
    margin-top: 30px;
  }
}
</style>
